<template>

  <div class="m-ctn-page">
    <ErrorPage
      :code="404"
      v-show="kill"
    ></ErrorPage>
    <div
      v-show="!kill"
      :id="`iframeWrap${menu.menuId}`"
      class="m-iframe-wrap"
    ></div>
  </div>
</template>
<script>
import ErrorPage from '@/components/ErrorPage'
import axios from 'axios'
export default {
  name: 'tabIframe',
  props: {
    menu: {
      type: Object,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      isFirst: true,
      oldMenu: null,
      iframeSrc: '',
      kill: false
    }
  },
  components: { ErrorPage },
  mounted () {
    if (this.menu.menuId !== 'home') {
      this.judgeUrl()
      this.initIframe()
    }
  },
  methods: {
    initIframe () {
      if (!this.kill && this.iframeSrc) {
        let iframeWrap = document.getElementById(`iframeWrap${this.menu.menuId}`)
        let newIframe = document.createElement('iframe')
        newIframe.style.width = '100%'
        newIframe.style.height = '100%'
        newIframe.setAttribute('id', `iframe${this.menu.menuId}`)
        newIframe.setAttribute('name', `${this.menu.permissionCode}`)
        newIframe.setAttribute('src', this.iframeSrc)
        newIframe.setAttribute('frameborder', 0)
        newIframe.setAttribute('allowfullscreen', true)
        iframeWrap.appendChild(newIframe)
        newIframe.onload = () => {
          let frameDoc = newIframe.contentDocument || newIframe.contentWindow.document
          frameDoc.onkeydown = e => {
            this.forbidBackSpace(e)
          }
        }
        this.oldMenu = JSON.parse(JSON.stringify(this.menu))
      }
    },
    forbidBackSpace (e) {
      let flag1 = true
      let flag2 = true
      const _forbidBackSpace = function (ev) {
        var obj = ev.target || ev.srcElement // 获取事件源
        var t = obj.type || obj.getAttribute('type') // 获取事件源类型
        // 获取作为判断条件的事件类型
        var vReadOnly = obj.readOnly
        var vDisabled = obj.disabled
        // 处理undefined值情况
        vReadOnly = vReadOnly === undefined ? false : vReadOnly
        vDisabled = vDisabled === undefined ? true : vDisabled
        // 当敲Backspace键时，事件源类型为密码或单行、多行文本的，
        // 并且readOnly属性为true或disabled属性为true的，则退格键失效
        flag1 =
          ev.keyCode === 8 &&
          (t === 'password' || t === 'text' || t === 'textarea') &&
          (vReadOnly || vDisabled)
        // 当敲Backspace键时，事件源类型非密码或单行、多行文本的，则退格键失效
        flag2 =
          ev.keyCode === 8 && t !== 'password' && t !== 'text' && t !== 'textarea'
      }
      _forbidBackSpace(e)

      // 判断
      if (flag2 || flag1) return false
    },
    judgeUrl () {
      this.kill = false
      let reg = /http[s]{0,1}:\/\/([\w.]+\/?)\S*/
      if (this.menu._info.showUrl && !reg.test(this.menu._info.showUrl) && this.menu._info.showUrl.indexOf('/') !== 0) {
        this.iframeSrc = `/${this.menu._info.showUrl}`
      } else if (!this.menu._info.showUrl) {
        this.kill = true
      } else {
        this.iframeSrc = this.menu._info.showUrl
        this.iframeSrc = this.iframeSrc
      }
    },
    async tryIframeLoad () {
      await axios.get(this.iframeSrc).then(() => {
        this.kill = false
      }).catch(err => {
        if (err.message.indexOf('Network Error') >= 0) {
          this.kill = false
          this.$message.error(this.$t('common.errorServe'))
        } else if (err.message.indexOf('404') >= 0) {
          this.kill = true
        }
      })
    }
  },
  watch: {
    menu: {
      handler () {
        if (this.menu.menuId !== 'home' && this.menu._info.showUrl !== this.oldMenu._info.showUrl) {
          this.judgeUrl()
          if (!this.kill) {
            let iframeWrap = document.getElementById(`iframeWrap${this.menu.menuId}`)
            let iframe = document.getElementById(`iframe${this.oldMenu.menuId}`)
            let _iframe = iframe.contentWindow
            if (iframe) {
              iframe.src = 'about:blank'
              try {
                _iframe.document.write('')
                _iframe.document.clear()
              } catch (e) {
                console.log(e)
              }
              iframeWrap.removeChild(iframe)
              this.isFirst = false
              let newIframe = document.createElement('iframe')
              newIframe.style.width = '100%'
              newIframe.style.height = '100%'
              newIframe.setAttribute('id', `iframe${this.menu.menuId}`)
              newIframe.setAttribute('name', `${this.menu.permissionCode}`)
              newIframe.setAttribute('src', this.iframeSrc)
              newIframe.setAttribute('frameborder', 0)
              newIframe.setAttribute('allowfullscreen', true)
              iframeWrap.appendChild(newIframe)
              newIframe.onload = () => {
                let frameDoc = newIframe.contentDocument || newIframe.contentWindow.document
                frameDoc.onkeydown = e => {
                  this.forbidBackSpace(e)
                }
              }
              this.oldMenu = JSON.parse(JSON.stringify(this.menu))
            } else {
              this.initIframe()
            }
          }
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="less" scoped>
.m-iframe-wrap {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
